module.exports = __webpack_public_path__ + "img/banner-1-m.02c58b9c.jpg";